// export const isExpires = () => {
//   let currmentTime = new Date().getTime();
//   let oldTime = JSON.parse(localStorage.getItem("TIME"));
// }
// import newMenu from './menu'
import { nextTick } from 'vue';
export const arrSort = (arr) => {
  let tempArr = [];
  arr.map((v) => {
    if (v.parentId == 0) {
      v.children = [];
      tempArr.push(v);
    }
  });
  tempArr.map((v) => {
    arr.map((value) => {
      v.menuId == value.parentId ? v.children.push(value) : null;
    });
  });
  return tempArr;
};
export const sumArr = (arr) => {
  return arr.reduce((prev, curr) => {
    let value = Number(curr);
    if (!isNaN(value)) {
      return prev + curr;
    } else {
      return prev;
    }
  }, 0);
};

// export const deleteSumArr = (arr) => {
//   return arr.reduce((prev, curr,index) => {
//     let value = Number(curr);
//     if (!isNaN(value)) {
//       return prev + curr;
//     } else {
//       return prev;
//     }
//   }, 0);
// }
export function filterarray (array, filtername) {
  return array.map((item) => {
    if (Object.prototype.hasOwnProperty.call(item, filtername)) {
      return item[filtername];
    } else {
      return 0;
    }
  });
}
export function isInArray (arr, value) {
  for (var i = 0; i < arr.length; i++) {
    if (value === arr[i]) {
      return true;
    }
  }
  return false;
}

export function getArrDifference (arr1, arr2) {
  return arr1.concat(arr2).filter(function (v, i, arr) {
    return arr.indexOf(v) === arr.lastIndexOf(v);
  });
} //比较两数组不同的值

export function arraydelete (array, val) {
  var index = array.indexOf(val);
  if (index > -1) {
    array.splice(index, 1);
  }
  return array;
}

export function changeshortcutclass (text, vm) {
  // const nodeList = document.querySelectorAll(
  //   `.el-picker-panel__shortcut`
  // );
  const nodeList = vm.childNodes[0].childNodes[0].childNodes;
  nodeList.forEach((node) => {
    if (node.innerText == text) {
      node.className = "el-picker-panel__shortcut selectedshortcut";
    } else {
      node.className = "el-picker-panel__shortcut";
    }
  });
}
export function clearallshortcutclass (vm) {
  // const nodeList = document.querySelectorAll(
  //   `.el-picker-panel__shortcut`
  // );
  const nodeList = vm.childNodes[0].childNodes[0].childNodes;
  nodeList.forEach((node) => {
    node.className = "el-picker-panel__shortcut";
  });
}

export const copyText = (text) => {
  let copyInput = document.createElement("textarea");

  // copyInput.type = 'text'

  copyInput.style.width = "1px";

  copyInput.style.height = "1px";

  copyInput.style.border = 0;

  copyInput.style.outline = 0;

  document.body.appendChild(copyInput);

  copyInput.value = text;

  copyInput.select();

  const result = document.execCommand("Copy");

  document.body.removeChild(copyInput);

  return result;
};

export function sortcheckedCities (originArr, choosedArr) {
  return choosedArr.sort((a, b) => {
    return originArr.indexOf(a) - originArr.indexOf(b);
  });
}
export const transferColumnArr = (array) => {
  let arr = [];
  array.map((v) => {
    arr.push(v.key);
  });
  console.log(arr);
  return arr;
};

export const menu = {
  roles: ["admin"],
  permissions: [
    "huawei:*",
    "publish：read",
    "*",
    "permission:predict:read",
    "popu:write",
    "uapp:*",
    "permission:read",
    "permission:allCountry",
    "permission:read:*",
    "permission:write:modsyspara",
    "permission:write",
    "operateLog:*",
    "publish：*",
    "uapp:read",
  ],
  menu: [
    {
      menuId: 2,
      menuName: "产品管理",
      menuAdr: "publishmng.html",
      parentId: 0,
      priority: 1,
    },
    {
      menuId: 3,
      menuName: "用户报表",
      menuAdr: "user_reten_analy.html",
      parentId: 0,
      priority: 2,
    },
    {
      menuId: 4,
      menuName: "推广报表",
      menuAdr: "popu.html",
      parentId: 0,
      priority: 3,
    },
    {
      menuId: 5,
      menuName: "收入报表",
      menuAdr: "incomeReport.html",
      parentId: 0,
      priority: 4,
    },
    {
      menuId: 6,
      menuName: "汇总报表",
      menuAdr: "collect.html",
      parentId: 0,
      priority: 5,
    },
    {
      menuId: 22,
      menuName: "细分维度报表",
      menuAdr: "single_dimension_collect.html",
      parentId: 6,
      priority: 5,
    },
    {
      menuId: 7,
      menuName: "总览报表",
      menuAdr: "totalReport.html",
      parentId: 0,
      priority: 6,
    },
    {
      menuId: 21,
      menuName: "全部维度报表",
      menuAdr: "all_dimension_collect.html",
      parentId: 6,
      priority: 6,
    },
    {
      menuId: 16,
      menuName: "参数配置",
      menuAdr: "sys_para.html",
      parentId: 0,
      priority: 7,
    },
    {
      menuId: 23,
      menuName: "LT预测表",
      menuAdr: "predict_retention.html",
      parentId: 6,
      priority: 7,
    },
    {
      menuId: 9,
      menuName: "权限管理系统",
      menuAdr: "permission.html",
      parentId: 0,
      priority: 7,
    },
    {
      menuId: 10,
      menuName: "用户管理",
      menuAdr: "users-new.html",
      parentId: 9,
      priority: 8,
    },
    {
      menuId: 11,
      menuName: "角色管理",
      menuAdr: "roles-new.html",
      parentId: 9,
      priority: 9,
    },
    {
      menuId: 15,
      menuName: "应用权限分配",
      menuAdr: "user_app.html",
      parentId: 9,
      priority: 13,
    },
    {
      menuId: 17,
      menuName: "登录日志",
      menuAdr: "login_log.html",
      parentId: 0,
      priority: 14,
    },
    {
      menuId: 19,
      menuName: "月度报表",
      menuAdr: "monthly_report.html",
      parentId: 0,
      priority: 16,
    },
    {
      menuId: 20,
      menuName: "月度推广报表",
      menuAdr: "monthly_popu.html",
      parentId: 19,
      priority: 17,
    },
    {
      menuId: 39,
      menuName: "广告账户管理",
      menuAdr: "ads.html",
      parentId: 20,
      priority: 21,
    },
  ],
  id: 1398,
  username: "ads123",
  password: "6b6813709310b032ad97ce5f7f12928d",
  name: "测试专用账号",
  department: "多比特",
  orgId: 1,
  parentOrgIds: [],
  parentOrgNames: [],
  gender: 2,
};

export function sortArr (arr) {
  // let arr = menu.menu;
  // let arr = newMenu;
  let obj = {},
    newArr = [];
  arr.map((item) => {
    obj[item.parentId] = [];
  });

  arr.map((item) => {
    item.children = [];
    obj[item.parentId].push(item);
  });
  newArr = obj[0];
  delete obj[0];
  for (let item in obj) {
    newArr.map((path) => {
      if (path.menuId == item) {
        path.children = obj[item];
        for (let node in obj) {
          path.children.map((childNode) => {
            if (childNode.menuId == node) {
              childNode.children = obj[node];
            }
          });
        }
      }
    });
  }
  return newArr;
}
// 解决精度丢失
export function add (num1, num2) {
  const num1Digits = (num1.toString().split(".")[1] || "").length;
  const num2Digits = (num2.toString().split(".")[1] || "").length;
  const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
  return (num1 * baseNum + num2 * baseNum) / baseNum;
}
/**
 *
 * @param {*} itemA a对象
 * @param {*} itemB b对象
 * @param {*} orderType 排序类型 ascend正序 descend逆序
 * @param {*} sortField 排序字段
 * @param {*} defaultOrderfield 默认排序字段，在非正序和逆序时使用该字段排序
 * @returns
 */
export const dataSortCompare = (itemA, itemB, orderType, sortField, defaultOrderfield) => {
  //判断是否是中文或者英文字符串(去%)
  let parseA = Number(String(itemA[sortField]).replace(/%$/, ""));
  let parseB = Number(String(itemB[sortField]).replace(/%$/, ""));
  let isEnStr = isNaN(parseA) || isNaN(parseB);
  if (orderType === "ascending") {
    return isEnStr ? (itemA[sortField] + "").localeCompare(itemB[sortField]) : parseA - parseB;
  } else if (orderType === "descending") {
    return isEnStr ? (itemB[sortField] + "").localeCompare(itemA[sortField]) : parseB - parseA;
  } else {
    return itemA[defaultOrderfield] - itemB[defaultOrderfield];
  }
};

export const removeSelectReadonly = (domRef) => {
  nextTick(() => {
    // ios 手机有延迟问题
    setTimeout(() => {
      // 情况一：单个
      let inputDom =
        domRef.$el.querySelector(".el-input__inner");
      inputDom.removeAttribute("readonly");
      // 情况二：表单中存在多个select   problemInfo表单ref
      const inputDoms =
        domRef.$el.querySelectorAll(".el-input__inner");
      for (var i = 0; i < inputDoms.length; i++) {
        inputDoms[i].removeAttribute("readonly");
      }
    }, 200);
  });
};
